<template>
	<div id="subscriptionGenerate" class="subscriptionGenerate">
		<div class="">
			<div class="row">
				<div class="col-3">
					<div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
						<span class="nav-link pointer" ref="navLinkSubscriptions" :class="(generatingShipment) ?  'disabled': ''" id="subscriptions-tab" data-toggle="pill" href="#subscriptions" role="tab" aria-controls="subscriptions" aria-selected="true">
							Subscripciones por generar
						</span>
						<span class="nav-link pointer" :class="(generatingShipment || !selectAnySubscription) ?  'disabled': ''" id="churchs-tab" data-toggle="pill" href="#churchs" role="tab" aria-controls="churchs" aria-selected="false">
							Iglesias
						</span>
						<span class="nav-link pointer" :class="(!selectAnySubscription || !selectAnyChurch) ?  'disabled': ''" id="generate-tab" data-toggle="pill" href="#generate" role="tab" aria-controls="generate" aria-selected="false">
							Generar Envios
						</span>
						<span class="nav-link pointer" ref="navLinkResumen" :class="(!resume) ?  'disabled': ''" id="resume-tab" data-toggle="pill" href="#resume" role="tab" aria-controls="resume" aria-selected="false">
							Resumen 
						</span>
						<hr>
						<span class="nav-link pointer" ref="navLinkLot" id="lot-tab" data-toggle="pill" href="#lot" role="tab" aria-controls="lot" aria-selected="false" @click="idLotSelected = -1">
							Lotes 
						</span>
						<span v-show="idLotSelected > -1" class="nav-link pointer" ref="navLinkLotChurch" id="lotChurch-tab" data-toggle="pill" href="#lotChurch" role="tab" aria-controls="lotChurch" aria-selected="false">
							Detalle Lote <span v-show="idLotSelected > -1">{{idLotSelected}}</span>
						</span>
						<span class="nav-link pointer" ref="navLinkShippingSubscription" id="shippingSubscription-tab" data-toggle="pill" href="#shippingSubscription" role="tab" aria-controls="shippingSubscription" aria-selected="false">
							Envios de Suscripción</span>
						</span>
					</div>
				</div>
				<div class="col-9">
					<div class="tab-content" id="v-pills-tabContent">
						<div class="tab-pane fade show active" id="subscriptions" role="tabpanel" aria-labelledby="subscriptions-tab">
							<table class="table table-sm table-12">
								<thead>
									<tr>
										<th>
											<i class="far fa-check-square" v-if="selectAllSubscription" @click="setSelectedAllSubscription(false)"></i>
											<i class="far fa-square" v-else @click="setSelectedAllSubscription(true)"></i>
										</th>
										<th>Suscripcion</th>
										<th>Periodo de envio</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listSubscriptions" :key="index" :class="(item.selected) ? 'text-black': 'text-black-50'" v-if="item.shipping_date != null">
										<td>
											<i class="far fa-check-square" v-if="item.selected" @click="item.selected = !item.selected; setSelectedSubscription()"></i>
											<i class="far fa-square" v-else @click="item.selected = !item.selected; setSelectedSubscription()"></i>
										</td>
										<td :title="'Código: ' + item.id">{{ item.name }}</td>
										<td>
											<select v-model="item.shipping_date" :disabled="!item.selected">
												<option v-for="(ite, inde) in listShippingDate(item)" :key="inde" :value="ite.shipping_date">{{ite.product}}</option>
											</select>
										</td>
									</tr>
								</tbody>
							</table>
							<div v-show="searchingProductsSubscription">
								<div class="jumbotron text-center">
									<h1 class="display-5">
										Buscando Suscripciones Pendientes
										<img src="@/assets/search-color.gif" width="100px"/>
									</h1>
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="churchs" role="tabpanel" aria-labelledby="churchs-tab">
							<div class="form-group row">
								<label for="staticEmail" class="col-sm-3 col-form-label">Campo Misionero</label>
								<div class="col-sm-6">
									<select class="form-control form-control-sm" v-model="entityId" @change="setListChurchs">
										<option value="-1">Todos</option>
										<option v-for="(item, index) in listEntities" :key="index" :value="item.id">{{item.name}}</option>
									</select>
								</div>
								<div class="col-sm-3">
									<button class="btn btn-sm btn-primary" @click="getChurchsByPendingSubscriptionsLocal" :disabled="loadingChurchs || !selectAnySubscription">
										<span v-if="!loadingChurchs">Buscar Iglesias</span>
										<span v-else>
											<div class="spinner-border spinner-border-sm" role="status">
												<span class="sr-only">Loading...</span>
											</div>
											Buscando iglesias...
										</span>
									</button>
								</div>
							</div>
							<table class="table table-sm table-hover">
								<thead>
									<tr>
										<th class="text-center">
											<i class="far fa-check-square" v-if="selectAllChurch" @click="setSelectedAllChurch(false)"></i>
											<i class="far fa-square" v-else @click="setSelectedAllChurch(true)"></i>
										</th>
										<th class="text-center">Tipo</th>
										<th class="text-center">Nombre</th>
										<th class="text-center">Coordinador</th>
										<th class="text-center">Dir. Envío</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listChurchs" :key="index" @dblclick="showConsole(item)">
										<td>
											<i class="far fa-check-square" v-if="item.exists" @click="item.exists = !item.exists; setSelectedChurch()"></i>
											<i class="far fa-square" v-else @click="item.exists = !item.exists; setSelectedChurch()"></i>
										</td>
										<td>{{ item.type_church.name }}</td>
										<td :title="item.id">{{ item.name }}</td>
										<td :class="(item.client == null) ? 'text-center' : ''">
											<i class="fas fa-minus text-black-50" v-if="item.client == null"></i>
											<span v-else>{{item.client.name + ' ' + item.client.surname}}</span>
										</td>
										<td :class="(item.client_address_send == null) ? 'text-center' : ''">
											<i class="fas fa-minus text-black-50" v-if="item.client_address_send == null"></i>
											<span v-else :title="(item.client_address_send.transport_id != null) ? item.client_address_send.transport.name : 'Sin Transporte'">{{item.client_address_send.text + ', ' + item.client_address_send.comuna}}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="tab-pane fade" id="generate" role="tabpanel" aria-labelledby="generate-tab">
							<button type="button" class="btn btn-primary btn-lg btn-block" v-if="!generatingShipment" @click="runGenerateAllLocal" :disabled="!selectAnyChurch || !selectAnySubscription">Comenzar</button>
							<div v-else>
								Generando envios de suscripción ({{(totalToGenerate - totalGenerate) + 1}} de {{totalToGenerate}})
								<div class="progress">
									<div class="progress-bar bg-info" role="progressbar" :style="'width: ' + percentageGenerated + '%'" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
								</div>
								<div class="text-right">
									<i>Generando suscripción de <span>{{churchCurrent}}</span></i>
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="resume" role="tabpanel" aria-labelledby="resume-tab">
							<table class="table table-sm table-12">
								<thead>
									<tr>
										<th>Iglesia</th>
										<th>Coordinador</th>
										<th>Observación</th>
										<th>Envío de Suscripción</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in objectLot.churchs" :key="index">
										<td>{{item.church.type_church.name}} {{item.church.name}}</td>
										<td v-if="item.church.client != null">
											{{item.church.client.name}} {{item.church.client.surname}}
										</td>
										<td v-else>
										</td>
										<td>{{item.observation}}</td>
										<td>{{item.order_id}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="tab-pane fade" id="lot" role="tabpanel" aria-labelledby="lot-tab">
							<lot-list-component
								@viewDetail="viewDetailLocal">
							</lot-list-component>
						</div>
						<div class="tab-pane fade" id="lotChurch" role="tabpanel" aria-labelledby="lotChurch-tab">
							<lot-church-list-component
								ref="lotChurchListComponent"
								:lot="lotSelected">
							</lot-church-list-component>
						</div>
						<div class="tab-pane fade" id="shippingSubscription" role="tabpanel" aria-labelledby="shippingSubscription-tab">
							<list-shipping-subscription-component>
							</list-shipping-subscription-component>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import subscription from '@/mixins/subscription'
import entity from '@/mixins/generals/entity.js'
import churchs from '@/mixins/generals/church.js'
import lots from '@/mixins/lots'

import LotListComponent from '@/components/LotListComponent.vue'
import LotChurchListComponent from '@/components/LotChurchListComponent.vue'
import ListShippingSubscriptionComponent from '@/components/ListShippingSubscriptionComponent.vue'

export default {
	name: 'SubscriptionGenerate',
	mixins: [axiosAction, errors, mixin, subscription, entity, churchs, lots],
	props: ['year'],
	data() {
		return {
			entityId: 0,
			generatingShipment: false,
			generateAll: false,
			churchCurrent: '',
			totalToGenerate: 0,
			resume: false,
			lotSelected: { id: -1 },
			idLotSelected: -1
		}
	},
	computed: {
		percentageGenerated() {
			return (((this.totalToGenerate - this.totalGenerate) + 1) * 100) / this.totalToGenerate
		},
		selectAllChurch() {
			let r = true
			this.listChurchs.forEach(church => {
				if(church.exists == false) {
					r = false
				}
			});
			return r
		},
		selectAnyChurch() {
			let r = false
			this.listChurchs.forEach(church => {
				if(church.exists == true) {
					r = true
				}
			});
			return r
		},
		selectAllSubscription() {
			let r = true
			this.listSubscriptions.forEach(subscription => {
				if(subscription.selected == false) {
					r = false
				}
			});
			return r
		},
		selectAnySubscription() {
			let r = false
			this.listSubscriptions.forEach(subscription => {
				if(subscription.selected == true) {
					r = true
				}
			});
			return r
		},
		totalGenerate() {
			return this.listChurchs.reduce(function(a,b) { 
										let c = (b.exists == true) ? 1 : 0
										return a + c
									}, 0)
		},
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Generacion de Envio de suscripciones año ' + this.year)
			this.getAllEntities()
			this.getProductSubscriptionByYearLocal()
			this.$refs.navLinkSubscriptions.click()
		},
		generateByChurchResultLocal(response) {
			if(response.data.success == true) {
				if(this.objectLot.id == 0) {
					this.objectLot.id = response.data.data.lot_id
				}
				this.objectLot.churchs.push(response.data.data)
				let id = response.data.data.church_id
				let index = this.listChurchs.map((el) => parseInt(el.id)).indexOf(parseInt(id))
				if(index > -1) {
					this.listChurchs[index].exists = false
				}
				if(this.generateAll) {
					this.runGenerateAll()
				} else {
					this.generatingShipment = false
				}
			} else {
				this.generateAll = false
				this.generatingShipment = false
			}
		},
		getPendingSubscriptionsLocal() {
			this.resume = false
			setTimeout(() => {
				this.getPendingSubscriptions(this.year)
			}, 1000);
		},
		getPendingSubscriptionsResultLocal(response) {
			this.listSubscriptions.forEach(element => {
				element.shipping_date_min = element.shipping_date
			});
			this.searchingProductsSubscription = false
		},
		getAllChurchsResultLocal(response) {
			if(this.listChurchs.length > 0) {
				this.listChurchs.forEach(church => {
					church.exists = true
				});
			}
		},
		getAllEntitiesResultLocal(response) {},
		getProductSubscriptionByYearLocal() {
			this.searchingProductsSubscription = true
			this.getProductSubscriptionByYear(this.year)
		},
		getProductSubscriptionByYearResultLocal(response) {
			this.listProductsSubscription.forEach(element => {
				element.subscription_product.forEach(e => {
					e.shipping_date = e.shipping_date.substring(0,10)
				});
			});
			this.getPendingSubscriptionsLocal()
		},
		getChurchsByPendingSubscriptionsLocal() {
			this.resume = false
			this.getChurchsByPendingSubscriptions(this.year, this.entityId, this.listSubscriptions)
		},
		listShippingDate(item) {
			let list = []
			let index = this.listProductsSubscription.map(el => parseInt(el.product_id)).indexOf(parseInt(item.id))
			if(index > -1) {
				list = this.listProductsSubscription[index].subscription_product.filter(el => {
					return el.shipping_date >= item.shipping_date_min
				})
			}
			return list
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'generateByChurchResult': this.generateByChurchResult(response); break;
				case 'getAllEntitiesResult': this.getAllEntitiesResult(response); break;
				case 'getAllChurchsResult': this.getAllChurchsResult(response); break;
				case 'getPendingSubscriptionsResult': this.getPendingSubscriptionsResult(response); break;
				case 'getProductSubscriptionByYearResult': this.getProductSubscriptionByYearResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		runGenerateAllLocal() {
			this.clearObjectLot()
			this.resume = false
			this.totalToGenerate = this.listChurchs.reduce(function(a,b) { 
										let c = (b.exists == true) ? 1 : 0
										return a + c
									}, 0)
			this.runGenerateAll()
		},
		runGenerateAll() {
			let find = false
			this.generateAll = true
			this.generatingShipment = true
			for (let church of this.listChurchs) {
				if(church.exists == true) {
					this.churchCurrent = church.type_church.name + ' ' + church.name
					this.generateByChurch(this.year, church, this.listSubscriptions, this.objectLot, this.entityId)
					find = true
					break
				}
			}
			if(find == false) {
				this.generateAll = false
				this.generatingShipment = false
				if(this.totalToGenerate > 0) {
					this.resume = true
					setTimeout(() => {this.$refs.navLinkResumen.click()}, 100)
					
				}
				this.totalToGenerate = 0
			}
		},
		setListChurchs() {
			this.listChurchs = []
		},
		setSelectedAllChurch(value) {
			this.listChurchs.forEach(church => {
				church.exists = value
			});
		},
		setSelectedAllSubscription(value) {
			this.listChurchs = []
			this.listSubscriptions.forEach(subscription => {
				subscription.selected = value
			});
		},
		setSelectedChurch() {

		},
		setSelectedSubscription() {
			this.listChurchs = []
		},
		viewDetailLocal(lot) {
			this.idLotSelected = lot.id
			this.lotSelected = lot
			setTimeout(() => {
				this.$refs.lotChurchListComponent.$refs.btnGetAllLotChurchs.click()
				this.$refs.navLinkLotChurch.click()
			}, 100)
		}
	},
	components: {
		'lot-list-component': LotListComponent,
		'lot-church-list-component': LotChurchListComponent,
		'list-shipping-subscription-component': ListShippingSubscriptionComponent
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>